import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ConfirmationModal, Typography, useOverlayContext } from 'seagull';
import { useStoreActions } from '~/contexts';
import { useLocaleKeys } from '~/i18n';
import styles from './DeactivateAPIKeyModal.module.scss';
export const DeactivateAPIKeyModal = (param)=>{
    let { apiKey, dismissModal, refresh } = param;
    const { t: apiKeysPageTexts } = useLocaleKeys('pages.apiKeysPage');
    const { t: commonTexts } = useLocaleKeys('common');
    const { api } = useStoreActions();
    const overlayContext = useOverlayContext();
    return /*#__PURE__*/ _jsx(ConfirmationModal, {
        bi: {
            primaryButton: {
                name: 'deactivate_a_p_i_key_confirm'
            },
            secondaryButton: {
                name: 'deactivate_a_p_i_key_cancel'
            }
        },
        title: apiKeysPageTexts.deactivateTitle(),
        skin: "danger",
        content: /*#__PURE__*/ _jsxs(Typography, {
            className: styles.deactivateApiKeyModalContent,
            testId: "deactivate-api-key-modal-content",
            children: [
                apiKeysPageTexts.deactivateContent(),
                " ",
                /*#__PURE__*/ _jsx("br", {}),
                " ",
                /*#__PURE__*/ _jsx("br", {}),
                " ",
                apiKeysPageTexts.deactivateConfirm()
            ]
        }),
        primaryButtonLabel: commonTexts.buttons.deactivateApiKey(),
        onPrimaryButtonClick: async ()=>{
            try {
                await api.business.deactivateAPIKey(apiKey.id);
                await refresh();
            } catch (error) {
                overlayContext.showErrorToast(commonTexts.toasts.failedToDeactivateApiKey(), 'deactivate-api-key-error');
            } finally{
                dismissModal();
            }
        },
        secondaryButtonLabel: commonTexts.buttons.cancel(),
        onSecondaryButtonClick: dismissModal,
        testId: "deactivate-api-key-modal"
    });
};
